import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

// Environment
import { environment } from "src/environments/environment";

// Models
import { ContactType } from "src/app/contacts/model/contactType.model";
import { ContactAssociationType } from "src/app/contacts/model/contactAssociationType.model";
import { Salutation } from "src/app/contacts/model/salutation.model";
import { JobFunction } from "src/app/contacts/model/jobFunction.model";
import { TypeGroupIds } from "../constants/category-groupid.constants";

@Injectable()

export class ContactHttpService {
    private baseUrl: string = environment.contactURL;
    private coreUrl: string = environment.coreUrl;
    private documentsStorageUrl: string = environment.documentStorageUrl;

    constructor(private http: HttpClient) { }

    // Dropdown Values API List
    getSalutations(): Observable<Salutation[]> {
        return this.http.get<Salutation[]>(`${this.baseUrl}Salutation/SalutationMinified`);
    }

    getContactRoles(): Observable<JobFunction[]> {
        return this.http.get<JobFunction[]>(`${this.baseUrl}Type/JobFunctionMinified`);
    }

    getContactTypes(): Observable<ContactType[]> {
        return this.http.get<ContactType[]>(`${this.coreUrl}Type?groupId=${TypeGroupIds.ContactType}`);
    }

    getAllContactTypesNew(): Observable<any>{
        return this.http.get<any>(`${environment.contactURL}Contact/PermittedContactTypeCount`)
    }

    getContactAssociationTypes(): Observable<ContactAssociationType[]> {
        return this.http.get<ContactAssociationType[]>(`${this.baseUrl}ContactAssociationType/ContactAssociationTypeMinified`);
    }

    
    downloadFilesAndFolder(data:{
        id:number;
        isDefaultContentType :boolean
    }):Observable<any>{
        return this.http.get<any>(this.documentsStorageUrl + `CloudAttachment/Download/${data?.id}?isDefaultContentType=${data?.isDefaultContentType}`);
      }

      getAllContactSource() {
        return this.http.get<any>(this.coreUrl + 'Source/SourceMinified')
            .toPromise()
            .then(res => res);
    }

    getAllTags() {
        return this.http.get<any>(`${this.baseUrl}Tag`);
    }

    countryCode() {
        return this.http.get(`${environment.apiUrlLogout}CountryCode`);
    }
}
